import { lazy } from "react";
import { Route } from "react-router-dom";

import AdminRoute from "../components/Routes/AdminRoute";

const AdminLogin = lazy(() => import("../pages/auth/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("../components/Admin/AdminDashboard"));
const AllListings = lazy(() =>
  import("../components/Admin/Listing/AllListings")
);
const AdminInbox = lazy(() => import("../components/Admin/AdminInbox"));
const AdminContactPageMessages = lazy(() =>
  import("../components/Admin/AdminContactPageMessages")
);
const AdminSupportEmail = lazy(() => import("../components/Admin/SupportEmail"));
const AdminEmailDetail = lazy(() =>
  import("../components/Admin/AdminEmailDetail")
);
const AdminManageUsers = lazy(() =>
  import("../components/Admin/Users/AdminManageUsers")
);
const AdminProfile = lazy(() => import("../components/Admin/AdminProfile"));
const UpdateProfileAdmin = lazy(() =>
  import("../components/Admin/UpdateProfileAdmin")
);
const ChangePasswordAdmin = lazy(() =>
  import("../components/Admin/ChangePasswordAdmin")
);

const AdminUserDetailsPage = lazy(() =>
  import("../components/Admin/Users/AdminUserDetailsPage")
);
const AdminUpdateUserPage = lazy(() =>
  import("../components/Admin/Users/AdminUpdateUserPage")
);
const AdminUserListingsPage = lazy(() =>
  import("../components/Admin/Users/AdminUserListingsPage")
);

const PropertyAddress = lazy(() =>
  import("../components/SubmitListing/PropertyAddress")
);
const PropertyDetails = lazy(() =>
  import("../components/SubmitListing/PropertyDetails")
);
const ImagesAndNewListing = lazy(() =>
  import("../components/SubmitListing/ImagesAndNewListing")
);
const AdminListingDetailsPage = lazy(() =>
  import("../components/Admin/Listing/AdminListingDetailsPage")
);

const AdminQuickUpdateUserListing = lazy(() =>
  import("../components/Admin/Users/AdminQuickUpdateUserListing")
);
const AdminUpdateUserListingAddress = lazy(() =>
  import("../components/Admin/Users/AdminUpdateUserListingAddress")
);
const AdminUpdateUserListingDetails = lazy(() =>
  import("../components/Admin/Users/AdminUpdateUserListingDetails")
);
const AdminUpdateUserListingImages = lazy(() =>
  import("../components/Admin/Users/AdminUpdateUserListingImages")
);

const AdminPartnerAgencies = lazy(() =>
  import("../components/Admin/Partner/AdminPartnerAgencies")
);
const AdminCreatePartner = lazy(() =>
  import("../components/Admin/Partner/AdminCreatePartner")
);
const AdminUpdatePartner = lazy(() =>
  import("../components/Admin/Partner/AdminUpdatePartner")
);

const CreateOther = lazy(() => import("../components/Admin/Other/CreateOther"));
const Others = lazy(() => import("../components/Admin/Other/Others"));
const UpdateOther = lazy(() => import("../components/Admin/Other/UpdateOther"));

const AdminManagePropertyTypes = lazy(() =>
  import("../pages/admin/managePropertyTypes/AdminManagePropertyTypes")
);
const UpdatePropertyType = lazy(() =>
  import("../pages/admin/managePropertyTypes/UpdatePropertyType")
);
const AdminManagePropertySubTypes = lazy(() =>
  import("../pages/admin/managePropertySubTypes/AdminManagePropertySubTypes")
);
const UpdatePropertySubType = lazy(() =>
  import("../pages/admin/managePropertySubTypes/UpdatePropertySubType")
);
const AdminManageOtherDetails = lazy(() =>
  import("../pages/admin/manageOtherDetails/AdminManageOtherDetails")
);

// Generic update page for all 15 "other property details" item types. The
// item key is read from the URL :itemKey segment (see route below).
const OtherDetailUpdate = lazy(() =>
  import("../pages/admin/manageOtherDetails/OtherDetailUpdate")
);

const AdminRoutes = ({ t, i18n }) => (
  <>
    <Route path="/pk/secure/admin/login" element={<AdminLogin t={t} i18n={i18n} />} />
    <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
    <Route path="/admin/dashboard/listings" element={<AdminRoute><AllListings /></AdminRoute>} />
    <Route path="/admin/inbox/:currentPage" element={<AdminRoute><AdminInbox /></AdminRoute>} />
    <Route path="/admin/contact-messages/:currentPage" element={<AdminRoute><AdminContactPageMessages /></AdminRoute>} />
    <Route path="/admin/inbox/user/email/:id" element={<AdminRoute><AdminEmailDetail /></AdminRoute>} />
    <Route path="/admin/support-email" element={<AdminRoute><AdminSupportEmail /></AdminRoute>} />
    <Route path="/admin/profile" element={<AdminRoute><AdminProfile /></AdminRoute>} />
    <Route path="/admin/update" element={<AdminRoute><UpdateProfileAdmin /></AdminRoute>} />
    <Route path="/admin/settings/change-password" element={<AdminRoute><ChangePasswordAdmin /></AdminRoute>} />

    <Route path="/admin/manage-users" element={<AdminRoute><AdminManageUsers /></AdminRoute>} />
    <Route path="/admin/user/:id" element={<AdminRoute><AdminUserDetailsPage /></AdminRoute>} />
    <Route path="/admin/update/user/:id" element={<AdminRoute><AdminUpdateUserPage /></AdminRoute>} />
    <Route path="/admin/user/:id/listings/:currentPage" element={<AdminRoute><AdminUserListingsPage t={t} /></AdminRoute>} />

    <Route path="/admin/create-listing/property-address" element={<AdminRoute><PropertyAddress /></AdminRoute>} />
    <Route path="/admin/create-listing/property-details" element={<AdminRoute><PropertyDetails /></AdminRoute>} />
    <Route path="/admin/create-listing/ui/submit" element={<AdminRoute><ImagesAndNewListing /></AdminRoute>} />

    <Route path="/admin/property-details/:slug/:id" element={<AdminRoute><AdminListingDetailsPage t={t} i18n={i18n} /></AdminRoute>} />

    <Route path="/pk/admin/quick-update-user-listing/property-address/:id" element={<AdminRoute><AdminQuickUpdateUserListing /></AdminRoute>} />
    <Route path="/pk/admin/update-user-listing/property-address/:id" element={<AdminRoute><AdminUpdateUserListingAddress /></AdminRoute>} />
    <Route path="/pk/admin/update-user-listing/property-details/:id" element={<AdminRoute><AdminUpdateUserListingDetails /></AdminRoute>} />
    <Route path="/pk/admin/update-user-listing/property-images/:id" element={<AdminRoute><AdminUpdateUserListingImages /></AdminRoute>} />

    <Route path="/admin/partner-agencies" element={<AdminRoute><AdminPartnerAgencies /></AdminRoute>} />
    <Route path="/admin/create-partner-agency" element={<AdminRoute><AdminCreatePartner /></AdminRoute>} />
    <Route path="/admin/edit-partner-agency/:id" element={<AdminRoute><AdminUpdatePartner /></AdminRoute>} />

    <Route path="/admin/other-infos" element={<AdminRoute><Others /></AdminRoute>} />
    <Route path="/admin/create-other-info" element={<AdminRoute><CreateOther /></AdminRoute>} />
    <Route path="/admin/edit-other-info/:id" element={<AdminRoute><UpdateOther /></AdminRoute>} />

    <Route path="/admin/manage-property-types" element={<AdminRoute><AdminManagePropertyTypes /></AdminRoute>} />
    <Route path="/admin/manage-property-types/:slug" element={<AdminRoute><UpdatePropertyType /></AdminRoute>} />
    <Route path="/admin/manage-property-sub-types" element={<AdminRoute><AdminManagePropertySubTypes /></AdminRoute>} />
    <Route path="/admin/manage-property-sub-types/:slug" element={<AdminRoute><UpdatePropertySubType /></AdminRoute>} />
    <Route path="/admin/manage-other-property-details" element={<AdminRoute><AdminManageOtherDetails /></AdminRoute>} />

    {/* Generic update route for all 15 "other details" item types — the
        :itemKey segment matches the `key` field in taxonomyConfig.js */}
    <Route path="/admin/manage-other-property-details/:groupKey/:itemKey/:slug" element={<AdminRoute><OtherDetailUpdate /></AdminRoute>} />
  </>
);

export default AdminRoutes;
